<template>
  <div class="tito-ticket-show--header">
    <div :class="statusClass">
      <font-awesome-icon :icon="statusIcon" fixed-width />
    </div>
    <div class="tito-ticket-show--heading">
      <h1 class="tito-ticket-show--heading-title">
        {{ releaseTitle }}
      </h1>
      <p class="tito-ticket-show--heading--description">
        {{ $t("views.tickets._header.unissued", locale) }}
      </p>
    </div>
    <div class="tito-ticket-show--details">
      <strong class="tito-ticket-show--details--index" v-if="registration">{{
        $t("views.tickets._header.heading", locale, {
          index: index,
          total: registration.tickets_count,
        })
      }}</strong>
      <em class="tito-ticket-show--details--reference">{{
        ticket.reference
      }}</em>
    </div>
  </div>
</template>

<script>
import ticketMixins from "js/src/mixins/TicketMixins.js";

export default {
  mixins: [ticketMixins],
  props: ["index", "locale", "registration", "ticket"],
};
</script>
